import { WebAuth } from 'auth0-js';
import { injectable } from 'inversify';

@injectable()
export class WebAuthContainer {
  public webAuth: WebAuth

  constructor() {
    this.webAuth = new WebAuth({
      audience: 'https://api.jybe.us',
      domain: <string>process.env.VUE_APP_AUTH0_DOMAIN,
      clientID: <string>process.env.VUE_APP_AUTH0_CLIENTID,
      redirectUri: <string>process.env.VUE_APP_AUTH0_REDIRECT,
      responseType: 'token id_token',
      scope: 'openid profile email'
    })
  }
}